import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BYPASS_UCT_EXP:control
// ?preferred_variant=BYPASS_UCT_EXP:variant_1

export const ByPassUctExpName = 'BYPASS_UCT_EXP' as const;

export type ByPassUctExpVariants = ToVariants<typeof ByPassUctExpVariants>;

export const ByPassUctExpVariants = {
	CONTROL: 'control',
	/**  Skip UCT on catalog titles and use UCT on non-catalog titles */
	VARIANT_1: 'variant_1',
} as const;

export default generate(ByPassUctExpName, ByPassUctExpVariants);
